import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogTitle,
  IconButton,
  Box,
  Typography,
  useMediaQuery,
  DialogContent,
} from "@mui/material";
import { Close } from "@mui/icons-material";
import React, { useEffect, useState } from "react";
import deleteIcon from "../../assets/images/bf.jpg";
import WarningIcon from "../../assets/images/warning.png";
import RefreshIcon from "../../assets/images/refresh.png";
import { getHeaderIcon } from "../../utils/Constant";
import { Icon } from "@iconify/react/dist/iconify.js";

function CustomConfirmation({
  openDelete,
  setOpenDelete,
  handleAgree,
  title,
  open,
  setOpen,
  headerHeading = null,
  infoTitle = null,
  additionalInfo = null,
}) {
  const [loading, setLoading] = useState(false);
  const isMobile = useMediaQuery("(max-width:600px)");

  const handleCloseDialog = () => {
    setOpenDelete(false);
    setLoading(false);
  };
  const handleCloseDialog1 = () => {
    setOpen(false);
    setLoading(false);
  };

  useEffect(() => {
    if (open || openDelete) {
      setLoading(false);
    }
  }, [open, openDelete]);

  return (
    <>
      <Dialog
        open={openDelete}
        onClose={handleCloseDialog}
        PaperProps={{
          style: {
            backgroundColor: "white",
            color: "black",
            boxShadow: "none",
            borderRadius: "8px",
            overflow: "hidden",
            width: isMobile ? "400px" : "500px !important",
            maxWidth: "600px",
            // zIndex: 1400,
          },
        }}
      >
        <Box
          sx={{
            backgroundColor: "var(--portal-primary-color)",
            color: "#ffffff",
            padding: "12px 16px",
            display: "flex",
            justifyContent: headerHeading ? "space-between" : "flex-end",
            alignItems: "center",
            width: isMobile ? "100%" : "100% !important",
          }}
        >
          {/* {open && (
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              {getHeaderIcon(headerHeading) && (
                <img
                  src={getHeaderIcon(headerHeading)}
                  alt="header-icon"
                  style={{ width: 24, height: 24 }}
                />
              )}
              <Typography sx={{ fontWeight: "bold", fontSize: "1.28rem" }}>
                {headerHeading}
              </Typography>
            </Box>
          )} */}

          {headerHeading && <div>{headerHeading}</div>}

          <IconButton onClick={handleCloseDialog} size="small">
            <Close style={{ fontSize: "23px", color: "#ffffff" }} />
          </IconButton>
        </Box>
        <DialogContent>
          <h2>
            {title ? title : "Are you sure you want to take this action?"}
          </h2>
          {additionalInfo && (
            <div className="alert alert-info d-flex w-100 mb-2" role="alert">
              <div style={{ height: "24px" }} className="me-3">
                <Icon
                  icon={"ep:info-filled"}
                  color="var(--portal-primary-color)"
                  width={24}
                  height={24}
                />
              </div>
              <div>
                {infoTitle && (
                  <p className="mb-1 text-capitalize">
                    <strong>{infoTitle}</strong>
                  </p>
                )}
                {additionalInfo && (
                  <span style={{ fontSize: "14px" }} className="mb-1">
                    {additionalInfo}
                  </span>
                )}
              </div>
            </div>
          )}
        </DialogContent>
        <DialogActions>
          <Button
            variant="outlined"
            sx={{
              fontSize: "15px",
              color: "var(--portal-primary-color)",
              borderColor: "var(--portal-primary-color)",
              "&:hover": {
                borderColor: "var(--portal-primary-color)",
                backgroundColor: "rgba(0, 0, 128, 0.04)",
              },
            }}
            onClick={handleCloseDialog}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            sx={{
              fontSize: "15px",
              backgroundColor: "var(--portal-primary-color)",
              "&:hover": {
                backgroundColor: "#000060",
              },
            }}
            disabled={loading}
            onClick={() => {
              setLoading(true);
              handleAgree();
            }}
          >
            {loading ? <CircularProgress size={24} /> : "Agree"}
          </Button>
        </DialogActions>
      </Dialog>
      {/* New to solve delete issue  */}

      <Dialog
        open={open}
        onClose={handleCloseDialog1}
        PaperProps={{
          style: {
            backgroundColor: "white",
            boxShadow: "none",
            borderRadius: "8px",
            overflow: "hidden",
            width: isMobile ? "400px" : "500px !important",
            maxWidth: "600px",
            // zIndex: 1400,
          },
        }}
      >
        <DialogTitle
          sx={{
            backgroundColor: "var(--portal-primary-color)",
            color: "#ffffff",
            padding: "12px 16px",
            display: "flex",
            justifyContent: headerHeading ? "space-between" : "flex-end",
            alignItems: "center",
            width: isMobile ? "100%" : "100% !important",
          }}
        >
          {/* {open && (
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              {getHeaderIcon(headerHeading) && (
                <img
                  src={getHeaderIcon(headerHeading)}
                  alt="header-icon"
                  style={{ width: 24, height: 24 }}
                />
              )}
              <Typography sx={{ fontWeight: "bold", fontSize: "1.28rem" }}>
                {headerHeading}
              </Typography>
            </Box>
          )} */}
          {headerHeading && <div>{headerHeading}</div>}

          <IconButton onClick={handleCloseDialog1} size="small">
            <Close style={{ fontSize: "23px", color: "#ffffff" }} />
          </IconButton>
        </DialogTitle>
        <DialogContent className="px-3 py-4">
          <h4>
            {title ? title : "Are you sure you want to take this action?"}
          </h4>

          {additionalInfo && (
            <div className="alert alert-info d-flex w-100 mb-2" role="alert">
              <div style={{ height: "24px" }} className="me-3">
                <Icon
                  icon={"ep:info-filled"}
                  color="var(--portal-primary-color)"
                  width={24}
                  height={24}
                />
              </div>
              <div>
                {infoTitle && (
                  <p className="mb-1 text-capitalize">
                    <strong>{infoTitle}</strong>
                  </p>
                )}
                {additionalInfo && (
                  <span style={{ fontSize: "14px" }} className="mb-1">
                    {additionalInfo}
                  </span>
                )}
              </div>
            </div>
          )}
        </DialogContent>
        <DialogActions>
          <Button
            variant="outlined"
            sx={{
              fontSize: "15px",
              color: "var(--portal-primary-color)",
              borderColor: "var(--portal-primary-color)",
              "&:hover": {
                borderColor: "var(--portal-primary-color)",
                backgroundColor: "rgba(0, 0, 128, 0.04)",
              },
            }}
            onClick={handleCloseDialog1}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            sx={{
              fontSize: "15px",
              backgroundColor: "var(--portal-primary-color)",
              "&:hover": {
                backgroundColor: "#000060",
              },
            }}
            disabled={loading}
            onClick={() => {
              setLoading(true);
              handleAgree();
            }}
          >
            {loading ? <CircularProgress size={24} /> : "Agree"}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default CustomConfirmation;
